import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import PlusLineIcon from "@/components/icons/plus-line"
import InvoicesTable from "./invoices.table"
import StatCard from "@/components/ux/stat.card"
import {
  InvoiceGet,
  formatInvoiceNumber,
  useInvoiceStats,
  useInvoicesActions,
} from "@/api/invoices"
import { useState } from "react"
import { CreatePaymentModal } from "@/payments/create-payment.modal"

export default function InvoicesHomeScreen() {
  const { stats } = useInvoiceStats()
  const [createPaymentInvoice, setCreatePaymentInvoice] =
    useState<InvoiceGet | null>(null)
  const { linkTransaction } = useInvoicesActions()

  const onLinkTransaction = async (txid: string) => {
    if (!createPaymentInvoice) throw new Error("No invoice selected")
    await linkTransaction(createPaymentInvoice.id, txid)
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-4 md:flex-row justify-between">
        <div className="text-xl font-semibold">Invoices</div>
        <Button asChild>
          <Link to="/invoices/create" data-testid="create-invoice">
            <PlusLineIcon />
            Create Invoice
          </Link>
        </Button>
      </div>
      {stats && (
        <div className="flex flex-col md:flex-row gap-4">
          <StatCard value={stats.total} label="Total" />
          <StatCard value={stats.draft} label="Draft" />
          <StatCard value={stats.overdue} label="Overdue" />
          <StatCard value={stats.outstanding} label="Outstanding" />
          <StatCard value={stats.paid} label="Paid" />
        </div>
      )}
      <InvoicesTable
        onLinkTransaction={(invoice) => setCreatePaymentInvoice(invoice)}
      />
      {createPaymentInvoice && (
        <CreatePaymentModal
          onClose={() => setCreatePaymentInvoice(null)}
          onLinkTransaction={onLinkTransaction}
          description={`Link a transaction to invoice #${formatInvoiceNumber(createPaymentInvoice.number)}`}
        />
      )}
    </div>
  )
}
